import {Document, Line, Page, Svg, Text, View} from "@react-pdf/renderer";
import {styles} from "./ModelAPdf";

export function ModelDPdf(props) {
    const {modelDTempObject} = props;
    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Model D Inschrijvingsformulier 'provincie'</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Provincie: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.provincie}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Provincie Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.provincieNr}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Voorzitter</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamVoorzitter}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamVoorzitter}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatVoorzitter}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrVoorzitter}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeVoorzitter}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteVoorzitter}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telVoorzitter}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmVoorzitter}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxVoorzitter}</Text>
                        </View>
                    </View>

                </View>

                <View style={styles.row}>
                    <View style={styles.field}>
                        <Text style={styles.fieldTitle}>Email: </Text>
                        <Text style={styles.fieldText}>{modelDTempObject.emailVoorzitter}</Text>
                    </View>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Secretaris</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamSecretaris}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamSecretaris}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatSecretaris}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrSecretaris}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeSecretaris}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteSecretaris}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telSecretaris}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmSecretaris}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxSecretaris}</Text>
                        </View>
                    </View>


                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailSecretaris}</Text>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Penningsmeester</Text>
                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamPenning}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamPenning}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatPenning}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrPenning}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodePenning}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeentePenning}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telPenning}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmPenning}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxPenning}</Text>
                        </View>
                    </View>


                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailPenning}</Text>
                </View>
            </View>
        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <Text style={styles.title}>Raadsleden</Text>

                <Text style={styles.smallestTile}>Raadslid 1</Text>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamRaadslid1}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamRaadslid1}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatRaadslid1}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrRaadslid1}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeRaadslid1}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteRaadslid1}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telRaadslid1}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmRaadslid1}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxRaadslid1}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailRaadslid1}</Text>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 2</Text>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamRaadslid2}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamRaadslid2}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatRaadslid2}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrRaadslid2}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeRaadslid2}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteRaadslid2}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telRaadslid2}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmRaadslid2}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxRaadslid2}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailRaadslid2}</Text>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 3</Text>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamRaadslid3}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamRaadslid3}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatRaadslid3}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrRaadslid3}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeRaadslid3}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteRaadslid3}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telRaadslid3}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmRaadslid3}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxRaadslid3}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailRaadslid3}</Text>
                </View>
                <View style={styles.rowCenter}>
                    <Svg height="5" width="495">
                        <Line x1="0" y1="5" x2="495" y2="5" strokeWidth={1} stroke="rgb(0,0,0)"/>
                    </Svg>
                </View>
                <Text style={styles.smallestTile}>Raadslid 4</Text>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamRaadslid4}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamRaadslid4}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatRaadslid4}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrRaadslid4}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeRaadslid4}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteRaadslid3}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telRaadslid4}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmRaadslid4}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxRaadslid4}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailRaadslid4}</Text>
                </View>
            </View>
        </Page>
        <Page size="A4" style={styles.page}>
            <View style={styles.section}>

                <Text style={styles.smallestTile}>Raadslid 5</Text>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Naam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.naamRaadslid5}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Voornaam: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.voornaamRaadslid5}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Straat: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.straatRaadslid5}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Nr: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.nrRaadslid5}</Text>
                        </View>
                    </View>
                </View>


                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Postcode: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.postcodeRaadslid5}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gemeente: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gemeenteRaadslid5}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.row}>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Tel: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.telRaadslid5}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Gsm: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.gsmRaadslid5}</Text>
                        </View>
                    </View>
                    <View style={styles.col}>
                        <View style={styles.field}>
                            <Text style={styles.fieldTitle}>Fax: </Text>
                            <Text style={styles.fieldText}>{modelDTempObject.faxRaadslid5}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.field}>
                    <Text style={styles.fieldTitle}>Email: </Text>
                    <Text style={styles.fieldText}>{modelDTempObject.emailRaadslid5}</Text>
                </View>
            </View>
        </Page>
    </Document>
}